<template>
  <div class="editAdd identityauth">
    <article>
      <ul>
        <li>
          请上传
          <span>{{ name }}</span>
          本人身份证照片
        </li>
        <li>
          <van-uploader v-model="portrait">
            <img v-if="!portrait.length" src="/static/images/storechange/portrait.png" />
            <img v-if="portrait.length" src="/static/images/storechange/portrait1.png" />
            <div class="content">
              <img v-if="portrait.length" :src="portrait[0].content" />
            </div>
          </van-uploader>
        </li>
        <li>
          <van-uploader v-model="idcardback">
            <img v-if="!idcardback.length" src="/static/images/storechange/idcardback.png" />
            <img v-if="idcardback.length" src="/static/images/storechange/idcardback1.png" />
            <div class="content">
              <img v-if="idcardback.length" :src="idcardback[0].content" />
            </div>
          </van-uploader>
        </li>
        <li>
          <van-uploader v-model="idcardfront">
            <img v-if="!idcardfront.length" src="/static/images/storechange/idcardfront.png" />
            <img v-if="idcardfront.length" src="/static/images/storechange/idcardfront1.png" />
            <div class="content">
              <img v-if="idcardfront.length" :src="idcardfront[0].content" />
            </div>
          </van-uploader>
        </li>
      </ul>
    </article>
    <footer>
      <button class="btn" @click="submit">确认提交</button>
    </footer>
  </div>
</template>

<script>
import { isWeixin, fenxiang, isApp } from '../../assets/common/js/config'
import wx from 'weixin-js-sdk'

export default {
  name: 'identityauth',
  data() {
    return {
      name: decodeURIComponent(this.$route.query.name),
      portrait: [],
      idcardback: [],
      idcardfront: [],
      datalist: []
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({ path: 'identityauth' })
    }
    let starname = ''
    if (this.name.length) {
      if (this.name.length > 2) {
        let len = this.name.length - 2
        starname = this.name[0]
        for (let i = 0; i < len; i++) {
          starname += '*'
        }
        starname += this.name[this.name.length - 1]
      } else {
        starname = this.name[0] + (this.name[1] ? '*' : '')
      }
    }
    this.name = starname
    this.getData()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  watch: {
    portrait(n) {
      if (n.length > 1) {
        this.portrait.splice(0, 1)
      }
    },
    idcardback(n) {
      if (n.length > 1) {
        this.idcardback.splice(0, 1)
      }
    },
    idcardfront(n) {
      if (n.length > 1) {
        this.idcardfront.splice(0, 1)
      }
    }
  },
  methods: {
    getData: function () {},
    afterRead: function (file) {
      console.log(file)
    },
    // 将base64转换为blob
    dataURLtoBlob: function (dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 将blob转换为file
    blobToFile: function (theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    random_string: function (n) {
      var num = Math.pow(10, n)
      return Math.ceil(Math.random() * num) + '' + new Date().getTime()
    },
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
    cosUploadImage(filllist, file, index, format, type, fn) {
      console.log(file)
      var that = this
      that.$cos.uploadFile({
        key: '/identityauth_h5' + file.file.name,
        file: file.file,
        success: function (data) {
          if (type == 'imgpath') {
            that.datalist.push(data)
          }
          index++
          if (index >= filllist.length) {
            if (typeof fn === 'function') {
              fn()
            }
          }
        }
      })
    },
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
    uploadImage(filllist, file, index, format, type, fn) {
      var imgName = 'idcard'
      var blob = this.dataURLtoBlob(file.content)
      var newFile = this.blobToFile(blob, imgName)
      var url = this.$ajax.getOssWeb_URL
      var that = this
      this.$customRequestAjax(url).then(async (res) => {
        if (res.data.code === 200) {
          const { accessid, host, policy, signature, dir } = res.data.data
          const fd = new FormData()
          let str = that.random_string(16) + newFile.name + format
          fd.append('OSSAccessKeyId', accessid)
          fd.append('policy', policy)
          fd.append('Signature', signature)
          fd.append('key', `${dir}${str}`)
          fd.append('Filename', `${dir}${str}`)
          fd.append('success_action_status', 200)
          fd.append('file', newFile)
          let config = {
            // 添加请求头
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          that.$axios.post(host, fd, config).then((res) => {
            if (res.status == 200 && res.statusText == 'OK') {
              // var img = that.imgUrl + `${dir}${str}`
              var path = `${dir}${str}`.replace('Uploads/', '')
              if (type == 'imgpath') {
                that.datalist.push(path)
              }
              index++
              if (index >= filllist.length) {
                if (typeof fn === 'function') {
                  fn()
                }
              }
            }
          })
        }
      })
    },
    submit: function () {
      // portrait
      // idcardback
      // idcardfront
      if (!this.portrait.length) {
        this.$toast('请上传人像面')
        return
      } else if (!this.idcardback.length) {
        this.$toast('请上传国徽面')
        return
      } else if (!this.idcardfront.length) {
        this.$toast('请上传身份证手持照')
        return
      }
      this.$toast.loading({
        mask: true,
        message: '正在提交',
        duration: 0
      })
      this.fileLen = 0
      this.datalist = []
      var that = this
      // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
      that[that.$cos.isCosSwitch == 1 ? 'cosUploadImage' : 'uploadImage'](
        that.portrait,
        that.portrait[that.fileLen],
        that.fileLen,
        '.png',
        'imgpath',
        function () {
          that.fileLen = 0
          that[that.$cos.isCosSwitch == 1 ? 'cosUploadImage' : 'uploadImage'](
            that.idcardback,
            that.idcardback[that.fileLen],
            that.fileLen,
            '.png',
            'imgpath',
            function () {
              that.fileLen = 0
              that[that.$cos.isCosSwitch == 1 ? 'cosUploadImage' : 'uploadImage'](
                that.idcardfront,
                that.idcardfront[that.fileLen],
                that.fileLen,
                '.png',
                'imgpath',
                function () {
                  that.submitAxios()
                }
              )
            }
          )
        }
      )
      // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
    },
    submitAxios: function () {
      var url = this.$ajax.setMeinfo_URL,
        that = this,
        data = {
          type: that.$route.query.storetype,
          id: that.$route.query.storeid,
          idcardfront: that.datalist[0],
          idcardback: that.datalist[1],
          idcardhand: that.datalist[2]
        },
        arg = isApp()
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code === 200) {
          this.$toast.clear()
          this.$dialog.close()
          this.$toast(res.data.msg)
          setTimeout(function () {
            if (arg == '') {
              that.$router.go(-1)
            } else if (arg.indexOf('xcx') >= 0) {
              wx.miniProgram.navigateBack()
            }
          }, 500)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.editAdd {
  background: #ffffff;
  ul {
    padding: 0 0.1rem 0 0.15rem;
    background: #fff;
    li {
      text-align: center;
      font-size: 0;
      margin-bottom: 0.15rem;
      height: 1.62rem;
      position: relative;
      &:first-of-type {
        line-height: 0.48rem;
        color: #333333;
        font-size: 0.15rem;
        text-align: center;
        height: auto;
        span {
          color: #fc0324;
        }
      }
    }
  }
  footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 0.63rem;
    padding: 0.1rem 0.11rem;
    .btn {
      border: 0;
      outline: none;
      border-radius: 0.25rem;
      display: block;
      font-size: 0.17rem;
      color: #ffffff;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, #fc0324, #f63a66);
      background: -webkit-linear-gradient(90deg, #fc0324, #f63a66);
      background: -o-linear-gradient(90deg, #fc0324, #f63a66);
      background: -moz-linear-gradient(90deg, #fc0324, #f63a66);
      background: -ms-linear-gradient(90deg, #fc0324, #f63a66);
    }
  }
}
</style>
<style lang="scss">
.identityauth {
  ul {
    li {
      .content {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        height: 0.87rem;
        width: 1.7rem;
        overflow: hidden;
        border-radius: 0.04rem;
        img {
          width: 100%;
        }
      }
      .van-uploader__preview {
        position: absolute;
        left: 0.1rem;
        top: 0.1rem;
      }
      .van-uploader__input-wrapper {
        width: 2.7rem;
        height: 1.62rem;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/storechange/identityauth.vue